export const formatMoney = (value, cents = false, mask = true) => {
  if (cents) {
    value = value / 100;
  }

  return parseFloat(value).toLocaleString('pt-br', mask ? {style: 'currency', currency: 'BRL'} : {minimumFractionDigits: 2, maximumFractionDigits: 2});
}